import React from "react";

import { Button } from "../../../../Shared/Buttons/Button";
import { dmnIdentity } from "../../../../../utils/dmnIdentity";
import { getEnvironmentProps } from "../../../../../utils/environment";
import dayjs from "dayjs";
import { useDiaryContext } from "../../../../../hooks/useDiaryContext";
import { ToggleButton } from "../../../../Shared/Buttons/ToggleButton";
import { document } from "@workspace/mobile";
import { Switch } from "../../../../ui/switch";
import {
  errorHandler,
  apiFetchNotOkHandler
} from "../../../../../APIs/errorHandler";
/**
 * DownloadPlaceCardsContent Props
 */
type DownloadPlaceCardsContentProps = {
  onClose?: () => void;
  onBack?: () => void;
};

/**
 * DownloadPlaceCardsContent Modal
 *
 * @param param0
 * @returns
 */
export const DownloadPlaceCardsContent = ({
  onBack,
  onClose
}: DownloadPlaceCardsContentProps) => {
  const { venueConfig, date } = useDiaryContext();
  const [fileType, setFileType] = React.useState<string>("pdf");

  const handleBack = () => {
    onBack?.();
  };

  const handleDownload = async () => {
    const token = await dmnIdentity.getAccessToken();
    const environmentVars = getEnvironmentProps(token);

    const url = new URL(
      `${environmentVars?.COLLINS_API_BASE_URL}/run-sheets/reservation-labels/${
        venueConfig?._id ?? ""
      }/${dayjs(date).format("YYYY-MM-DD")}`
    );
    url.searchParams.set("output", fileType);
    url.searchParams.set("source", "admin");

    try {
      const request = await fetch(url, {
        headers: {
          authorization: `Bearer ${token}`
        },
        method: "GET"
      });

      if (!request.ok) {
        apiFetchNotOkHandler(request, "Error downloading place cards");
        return;
      }

      const arrBuffer = await request.arrayBuffer();

      const file = new Blob([arrBuffer], { type: "application/pdf" });

      // Read out the data into a file reader
      const fileReader = new FileReader();

      fileReader.onloadend = async () => {
        // Parse out the result to get the document data.
        const result = fileReader.result as string;

        const [, mimeType, , data] = result.split(/[:;,]+/);
        const fileName = "guest-list.csv";
        document.open({ mimeType, data, fileName });
      };

      fileReader.readAsDataURL(file);
    } catch (error) {
      errorHandler(error, "Error downloading place cards");

      return;
    }

    onClose?.();
  };

  return (
    <div className="DownloadFileCotainer flex flex-col flex-1">
      <div className="DownloadFileContent flex-1 flex flex-col">
        <p>Creates place cards for customers. </p>
        <p>
          <strong>File type</strong>
        </p>
        <div>
          <div className="InlineTabsWrapper InlineTabsWrapperStart">
            <ToggleButton
              text1="PDF"
              text2="Excel/CSV"
              selected={fileType === "pdf"}
              onClick={() => {
                setFileType(fileType === "pdf" ? "csv" : "pdf");
              }}
            />
          </div>
        </div>
        <p>
          <strong>Include preorder items?</strong>
        </p>
        <div>
          <Switch
            name={"overCapacity"}
            checked={false}
            onCheckedChange={() => {
              // setIsGoOverCapacitySelected(
              //     e.checked
              // );
            }}
          />
        </div>
      </div>
      <div className="DownloadFileFooter flex-none flex flex-row gap-2.5">
        <Button className="DownloadFileFooterButton" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="DownloadFileFooterButton"
          onClick={handleDownload}
          type="primary"
        >
          Download Place Cards
        </Button>
      </div>
    </div>
  );
};
